import { buildRpaDomainSeoBundle } from "../rpaSeoUtils";

export const TELECOM_DOMAIN_INTRO = {
  title: "Telecom",
  content: "Document AI + RPA and workflow automation across Fixed Broadband, Mobile Services. Each use case includes challenge and solution detail, process diagrams, and human-in-the-loop review for enterprises in India, UAE, KSA, UK, and USA.",
  seoDescription: "Telecom automation use cases — document AI + RPA and workflow automation across Fixed Broadband, Mobile Services. Validation, approvals, system updates, and exception handling.",
};

const slugify = (label) =>
  label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) {
  return {
    ...uc,
    groupId: slugify(uc.subIndustry),
    seoTitle: uc.title,
    title: uc.shortTitle || uc.title,
    systems: uc.systems || SYSTEMS,
  };
}

const SYSTEMS = "BSS/OSS, CRM, Network Monitoring, ITSM, Email, Power BI";

const RAW = [
  {
    id: "new-connection-order-provisioning",
    subIndustry: "Fixed Broadband",
    department: "Provisioning",
    businessProcess: "New connection order provisioning",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "New connection order provisioning",
    title: "New Connection Order Provisioning Automation for Telecom",
    seoKeywords: "telecom, new connection order provisioning, AI automation, RPA, agentic AI",
    challenge: "Provisioning teams manually check feasibility, customer documents, slot availability and order status.",
    solution: "Implement RPA + Workflow Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "RPA + Workflow Automation",
    buyerPersona: "COO, Provisioning Head",
    systems: "CRM, OSS, Field Service, Billing, Email",
    agentsRequired: "RPA Posting Agent, New Validation Agent, Exception Agent",
    inputData: "Emails, forms, system records, task notes, master data and new connection order provisioning process rules",
    outputActions: "Validated workflow record, task assignment, status update and exception report for new connection order provisioning",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "sim-and-ekyc-document-validation",
    subIndustry: "Mobile Services",
    department: "KYC",
    businessProcess: "SIM and eKYC document validation",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "SIM and eKYC document validation",
    title: "Sim And Ekyc Document Validation Automation for Telecom",
    seoKeywords: "telecom, sim and ekyc document validation, AI automation, RPA, agentic AI, document AI",
    challenge: "KYC documents and forms are manually validated before SIM activation or account changes.",
    solution: "Implement Document AI + RPA to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "Document AI + RPA",
    buyerPersona: "Compliance Head, Retail Operations Head",
    systems: "CRM, KYC System, DMS, Identity Verification Platform",
    agentsRequired: "Document Extraction Agent, SIM Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and sim and ekyc document validation rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready sim and ekyc document validation record",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
];
export const TELECOM_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Fixed Broadband", "Mobile Services"];
export const TELECOM_GROUPS = GROUP_ORDER.map((label) => ({
  id: slugify(label),
  label,
})).filter((g) => TELECOM_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildRpaDomainSeoBundle({
  domainSlug: 'telecom-domain',
  domainIntro: TELECOM_DOMAIN_INTRO,
  useCases: TELECOM_USE_CASES,
});
export const TELECOM_USE_CASES_SEO = seo.useCasesSeo;
export const TELECOM_DOMAIN_FAQS = seo.domainFaqs;
export const TELECOM_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const TELECOM_FAQ_JSONLD = seo.faqJsonLd;
export const TELECOM_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const TELECOM_WEBPAGE_JSONLD = seo.webPageJsonLd;

